// @ts-nocheck
import {useState, useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'
import axios from 'axios'
import './rate-support.scss'

const API_URL = process.env.REACT_APP_API_URL

export function RateSupportPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const initialRating = searchParams.get('rating')

  const [loading, setLoading] = useState(true)
  const [submitting, setSubmitting] = useState(false)
  const [ticketInfo, setTicketInfo] = useState<any>(null)
  const [error, setError] = useState('')
  const [rating, setRating] = useState(initialRating ? parseInt(initialRating) : 0)
  const [hoveredRating, setHoveredRating] = useState(0)
  const [feedback, setFeedback] = useState('')
  const [submitted, setSubmitted] = useState(false)

  // Hide splash screen since this page is outside the App wrapper
  useEffect(() => {
    const splashScreen = document.getElementById('splash-screen')
    if (splashScreen) {
      splashScreen.style.display = 'none'
    }
  }, [])

  useEffect(() => {
    if (token) {
      loadTicketInfo()
    } else {
      setError('קישור לא תקין')
      setLoading(false)
    }
  }, [token])

  const loadTicketInfo = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/ticket-rating/${token}`)
      setTicketInfo(response.data)
      if (response.data.already_rated) {
        setRating(response.data.existing_rating)
        setFeedback(response.data.existing_feedback || '')
        setSubmitted(true)
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'קישור לא תקין או שפג תוקפו')
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (rating === 0) {
      setError('נא לבחור דירוג')
      return
    }

    setSubmitting(true)
    setError('')

    try {
      await axios.post(`${API_URL}/api/ticket-rating/${token}`, {
        rating,
        feedback
      })
      setSubmitted(true)
    } catch (err: any) {
      setError(err.response?.data?.error || 'שגיאה בשליחת הדירוג')
    } finally {
      setSubmitting(false)
    }
  }

  if (loading) {
    return (
      <div className="rate-support-page" dir="rtl">
        <div className="rate-support-container">
          <div className="loading-state">
            <div className="spinner"></div>
            <span>טוען...</span>
          </div>
        </div>
      </div>
    )
  }

  if (error && !ticketInfo) {
    return (
      <div className="rate-support-page" dir="rtl">
        <div className="rate-support-container">
          <div className="error-state">
            <i className="bi bi-exclamation-circle"></i>
            <h3>שגיאה</h3>
            <p>{error}</p>
          </div>
        </div>
      </div>
    )
  }

  if (submitted) {
    return (
      <div className="rate-support-page" dir="rtl">
        <div className="rate-support-container">
          <div className="success-state">
            <div className="success-icon">
              <i className="bi bi-heart-fill"></i>
            </div>
            <h2>תודה רבה!</h2>
            <p>המשוב שלך התקבל בהצלחה</p>
            <div className="rating-display">
              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  key={star}
                  className={`bi ${star <= rating ? 'bi-star-fill' : 'bi-star'}`}
                ></i>
              ))}
            </div>
            {feedback && (
              <div className="feedback-display">
                <p>"{feedback}"</p>
              </div>
            )}
            <p className="thank-you-text">
              המשוב שלך עוזר לנו להשתפר ולתת שירות טוב יותר
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="rate-support-page" dir="rtl">
      <div className="rate-support-container">
        <div className="rate-support-header">
          <img
            src="https://zipper.ams3.digitaloceanspaces.com/assets/d-code-logo-light.png"
            alt="FB Zipper"
            className="logo"
          />
          <h1>איך היה השירות?</h1>
          {ticketInfo && (
            <p className="ticket-info">
              פנייה #{ticketInfo.ticket_number} - {ticketInfo.subject}
            </p>
          )}
        </div>

        <form onSubmit={handleSubmit} className="rate-support-form">
          {error && (
            <div className="error-alert">
              <i className="bi bi-exclamation-triangle-fill"></i>
              <span>{error}</span>
            </div>
          )}

          <div className="rating-section">
            <p className="rating-label">
              {ticketInfo?.customer_name ? `שלום ${ticketInfo.customer_name}, ` : ''}
              נשמח לשמוע מה חשבת על השירות שקיבלת
            </p>

            <div className="star-rating">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  className={`star-btn ${star <= (hoveredRating || rating) ? 'active' : ''}`}
                  onMouseEnter={() => setHoveredRating(star)}
                  onMouseLeave={() => setHoveredRating(0)}
                  onClick={() => setRating(star)}
                >
                  <i className={`bi ${star <= (hoveredRating || rating) ? 'bi-star-fill' : 'bi-star'}`}></i>
                </button>
              ))}
            </div>

            <div className="rating-text">
              {rating === 1 && 'גרוע מאוד'}
              {rating === 2 && 'לא טוב'}
              {rating === 3 && 'בסדר'}
              {rating === 4 && 'טוב'}
              {rating === 5 && 'מעולה!'}
            </div>
          </div>

          <div className="feedback-section">
            <label>רוצה לשתף עוד משהו? (אופציונלי)</label>
            <textarea
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              placeholder="ספר לנו מה היה טוב ומה אפשר לשפר..."
              rows={4}
            />
          </div>

          <button type="submit" className="submit-btn" disabled={submitting || rating === 0}>
            {submitting ? (
              <>
                <span className="spinner"></span>
                שולח...
              </>
            ) : (
              <>
                <i className="bi bi-send"></i>
                שלח משוב
              </>
            )}
          </button>
        </form>

        <div className="rate-support-footer">
          <p>© {new Date().getFullYear()} FB Zipper. כל הזכויות שמורות.</p>
        </div>
      </div>
    </div>
  )
}
